import GeoJSON from "ol/format/GeoJSON"
import { fromLonLat, toLonLat } from "ol/proj"

export function getClosestPointOnPathGeoJSON(pathGeoJSON: any, lon: number, lat: number) {
    try {
        if (!pathGeoJSON) return null
        const fmt = new GeoJSON()
        const features: any[] = fmt.readFeatures(pathGeoJSON, {
            dataProjection: "EPSG:4326",
            featureProjection: "EPSG:3857",
        }) as any
        if (!Array.isArray(features) || features.length === 0) return null

        const p = fromLonLat([lon, lat])
        let best: number[] | null = null
        let bestDist2 = Number.POSITIVE_INFINITY

        for (const f of features) {
            const geom = f?.getGeometry?.()
            if (!geom?.getClosestPoint) continue
            const cp = geom.getClosestPoint(p)
            if (!Array.isArray(cp) || cp.length < 2) continue
            const dx = cp[0] - p[0]
            const dy = cp[1] - p[1]
            const d2 = dx * dx + dy * dy
            if (d2 < bestDist2) {
                bestDist2 = d2
                best = cp
            }
        }

        if (!best) return null
        const [clon, clat] = toLonLat(best)
        return { longitude: clon, latitude: clat }
    } catch {
        return null
    }
}

export function filterPathsByQuery(pathsList: any[], query: any) {
    const matchesQuery = (path: any, query: any) => {
        const name = (path?.Name ?? "").toString().toLowerCase()
        const roadName = (path?.RoadName ?? "").toString().toLowerCase()
        const q = (query ?? "").toString().trim().toLowerCase()

        if (!q) return false
        if (!name && !roadName) return false
        return `${roadName} ${name}`.includes(q)
    }

    if (!Array.isArray(pathsList) || pathsList.length === 0) return []
    return pathsList.filter((path: any) => matchesQuery(path, query))
}

export function parseCoordinatesResult(searchQuery: string) {
    const numberMatches = searchQuery.match(/-?\d+(?:[.,]\d+)?/g)
    if (!numberMatches) return

    const [latFromInput, lonFromInput] = numberMatches.map(Number)
    if (Number.isFinite(latFromInput) && Number.isFinite(lonFromInput)) {
        return {
            lat: latFromInput.toFixed(8),
            lon: lonFromInput.toFixed(8),
            name: `${latFromInput} с. ш. ${lonFromInput} в. д.`
        }
    }
}

export function normalizePathPositionInput(value: any): string | null {
    const kmPlus = /^\d+\+\d{0,3}$/
    const kmMinus = /^\d+\-\d{0,3}$/
    const kmOnly = /^\d+$/

    if (kmPlus.test(value)) {
        const [km, m]: [string, string] = value.split("+")
        return `${km}+${m.padStart(3, "0")}`
    }

    if (kmMinus.test(value)) {
        const [km, m]: [string, string] = value.split("-")
        return `${km}-${m.padStart(3, "0")}`
    }

    if (kmOnly.test(value)) {
        return `${value}+000`
    }
    
    return null
}

